export let testMode = false;
export function enableTestMode() {
    testMode = true;
}
export const exposeTestId = () => testMode;
